<template>
  <div>
    <el-table
      :data="claimsRemovalRequest.data"
      :default-sort="{ prop: order_column, order: order_type }"
      @sort-change="sort"
      class="w100"
      stripe
      v-loading="loading"
    >
      <el-table-column
          label="Select all"
          align="center"
          width="100%"
      >
        <template slot="header" slot-scope="scope">
          <el-checkbox
              v-model="selectAll"
              @change="toggleSelectAll"
          >
          </el-checkbox>
        </template>
        <template slot-scope="props" v-if="props.row.user_status !== 1">
          <el-checkbox
              :value="isRowSelected(props.row)"
              @change="toggleRowSelection(props.row)"
          >
          </el-checkbox>
        </template>
      </el-table-column>
      <el-table-column label="Video" prop="title" width="150%">
        <template slot-scope="props">
          <a
              :href="`https://youtube.com/watch?v=${props.row.videoId}`"
              target="_blank"
          >
            <img
                :src="'https://img.youtube.com/vi/' + props.row.videoId+ '/hqdefault.jpg'"
                alt=""
                class="youtube-image"
            />
          </a>
        </template>
      </el-table-column>
      <el-table-column
          label="Video ID"
          prop="videoId"
          sortable
      ></el-table-column>
      <el-table-column
          label="Claim ID"
          prop="claimId"
          sortable
      ></el-table-column>
      <el-table-column label="Video Title" prop="title" width="150%" sortable>
        <template slot-scope="props">
          <a
              :href="`https://youtube.com/watch?v=${props.row.videoId}`"
              target="_blank"
          >
            {{ props.row.title }}
          </a>
        </template>
      </el-table-column>
      <el-table-column
          label="Channel name"
          prop="channelId"
          sortable
          width="150%"
      >
        <template slot-scope="props">
          <a
              :href="`https://youtube.com/channel/${props.row.channelId}`"
              target="_blank"
          >
            {{ props.row.channelName }}
          </a>
        </template>
      </el-table-column>
      <el-table-column
        label="Label"
        prop="label"
        sortable
        width="100%"
      ></el-table-column>
      <el-table-column label="Asset" prop="asset" sortable></el-table-column>
      <el-table-column label="Video published" prop="published_at" width="150%" sortable>
        <template slot-scope="props">
          {{ props.row.published_at | date }}
        </template>
      </el-table-column>
      <el-table-column label="Status" prop="user_status" sortable>
        <template slot-scope="props">
          <el-tag v-if="isRequestRejected(props.row)" type="danger">
            Rejected
          </el-tag>
          <el-tag v-else-if="isRequestActive(props.row)" type="success">
            Approved
          </el-tag>
          <el-tag v-else type="warning">
            Pending
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="User action">
        <template slot-scope="props">
          <div v-if="isRequestRejected(props.row)">
            {{ getUserActionMessage(props.row, 'rejected') }}
          </div>
          <div v-else-if="isRequestActive(props.row)">
            {{ getUserActionMessage(props.row, 'active') }}
          </div>
          <div v-else>
            {{ getUserActionMessage(props.row, 'pending') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Date of action" prop="updated_at">
        <template slot-scope="props" v-if="props.row.user_status !== 0">
          {{ props.row.updated_at | date }}
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right" width="100%">
        <template slot-scope="props" v-if="!isRequestActive(props.row)">
          <el-tooltip content="Approve" placement="right" v-if="shouldShowButton(props.row, 'release')">
            <el-button
                type="success"
                circle
                size="small"
                icon="el-icon-check"
                @click="release(props.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="Reject" placement="right" v-if="shouldShowButton(props.row, 'rejectRelease')">
            <el-button
                type="danger"
                circle
                size="small"
                icon="el-icon-close"
                class="mt10"
                @click="reject(props.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="Approve" placement="right" v-if="shouldShowButton(props.row, 'confirm')">
            <el-button
                type="success"
                circle
                size="small"
                icon="el-icon-check"
                class="mt10"
                @click="confirm(props.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="Reject" placement="right" v-if="shouldShowButton(props.row, 'rejectConfirm')">
            <el-button
                type="danger"
                circle
                size="small"
                icon="el-icon-close"
                class="mt10"
                @click="reject(props.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        class="float-right"
        background
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="claimsRemovalRequest.current_page"
        :page-sizes="[5, 10, 25, 50, 100]"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="claimsRemovalRequest.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  props: {
    status: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState('youtubeClaims', [
      'claimsRemovalRequest',
      'loading',
      'order_column',
      'order_type',
      'page',
      'page_size',
      'selectAll',
      'selectedRows',
    ]),
    selectAll: {
      get() {
        return this.$store.state.youtubeClaims.selectAll;
      },
      set(value) {
        this.setSelectAll(value);
        console.log('select all:'.value)
      }
    }
  },

  methods: {
    ...mapMutations('youtubeClaims', [
      'setPage',
      'setPageSize',
      'setOrdering',
      'setSelectAll',
      'setSelectedRows'
    ]),
    ...mapActions('youtubeClaims', [
      'readRequestedClaims',
      'readLabels',
      'releaseClaim',
      'confirmClaim',
      'rejectClaim',
      'setStatus'
    ]),
    toggleSelectAll() {
        if (this.selectAll) {
          if (this.claimsRemovalRequest.data) {
            const filteredClaimIds = this.claimsRemovalRequest.data
                .filter(row => row.release_request !== 1 && row.confirm_request !== 1)
                .map(row => row.claimId);
            // Set the selected rows to the filtered rows
            this.setSelectedRows([...filteredClaimIds]);
          }else {
            // Handle the case when data is not available
            console.error('Data is not available');
          }
        } else {
          // If 'select all' is unchecked, clear the selection
          this.setSelectedRows([]);
        }
    },
    toggleRowSelection(row) {
      // Toggle the selection state of the clicked row
      const index = this.selectedRows.indexOf(row.claimId)
      if (index === -1) {
        this.selectedRows.push(row.claimId);
      } else {
        this.selectedRows.splice(index, 1);
      }
      // Update 'select all' flag based on selected rows count
      this.setSelectAll(this.selectedRows.length === this.claimsRemovalRequest.data.filter(row => row.user_status !== 1).length);
    },

    isRowSelected(row) {
      return this.selectedRows.includes(row.claimId);
    },
    release(row) {
      this.$confirm('You will release this claim. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.releaseClaim(row.claimId)
          //this.readRequestedClaims({ claim_type: 'Public', status: this.selectedStatus });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Claim cancelled'
          })
        })
    },
    confirm(row) {
      this.$confirm('You will confirm this claim. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.confirmClaim(row.claimId)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Claim cancelled'
          })
        })
    },
    reject(row) {
      this.$confirm('You will reject this claim. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
          .then(() => {
            this.rejectClaim(row.claimId)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: 'Claim reject cancelled'
            })
          })
    },
    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.readRequestedClaims({ claim_type: 'Public', status: this.status })
    },
    currentChange(currentPage) {
      this.setPage(currentPage)
      this.readRequestedClaims({ claim_type: 'Public', status: this.status })
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.readRequestedClaims({ claim_type: 'Public', status: this.status })
    },
    shouldShowButton(item, actionType) {
      switch (actionType) {
        case 'release':
          return item.release_request !== 1 && item.confirm_request === null;
        case 'confirm':
          return item.status === 'Potential' && item.release_request === null && item.confirm_request !== 1;
        case 'rejectConfirm':
          return item.release_request === null && item.confirm_request !== 2;
        case 'rejectRelease':
          return item.release_request !== 2 && item.confirm_request === null;
        default:
          return false;
      }
    },
    isRequestActive(item) {
      return item.release_request === 1 || item.confirm_request === 1;
    },
    isRequestRejected(item) {
      return item.release_request === 2 || item.confirm_request === 2;
    },
    getUserActionMessage(row, status) {
      let action = '';

      if (row.release_request !== null) {
        if (status === 'rejected') action = 'Claim release';
        if (status === 'pending') action = 'Claim release';
        if (status === 'active') action = 'Claim release';
      } else if (row.confirm_request !== null) {
        if (status === 'rejected') action = 'Claim confirm';
        if (status === 'pending') action = 'Claim confirm';
        if (status === 'active') action = 'Claim confirm';
      }
      return action;
    }
  },

  created() {
    this.setStatus(this.status)
    this.readRequestedClaims({ claim_type: 'Public'})
    this.readLabels()
  }
}
</script>
<style scoped>
.youtube-image{
  width: 120px;
}
</style>
